<script lang="ts" setup>
import { PropType } from 'vue'

/* Assets */
import ProductNoImage from '~/assets/images/ProductNoImage.png'
import GeneratorBackgroud from '~/assets/images/generator-background.webp'

/* Types */
import { CompositionOfWok } from '~/types/api/api-v3/make-wok'

const props = defineProps({
  compositionOfWok: {
    type: Object as PropType<CompositionOfWok>,
    required: true,
  },
})
</script>

<template>
  <svg viewBox="0 0 15 10">
    <rect
      id="background"
      fill="url(#background-gradient)"
      width="100%"
      height="100%"
    />
    <image :href="GeneratorBackgroud" width="100%" height="100%" />
    <defs>
      <linearGradient id="background-gradient">
        <stop stop-color="white" />
        <stop offset="1" stop-color="#FAFAFA" />
      </linearGradient>

      <clipPath id="common">
        <polygon
          :points="
            props.compositionOfWok['Начинка']
              ? '0 0, 15 0, 15 10'
              : '0 0, 15 0, 15 10, 0 10'
          "
        />
      </clipPath>
      <clipPath id="fill">
        <polygon
          :points="
            props.compositionOfWok['Основа']
              ? '0 0, 0 10, 15 10'
              : '0 0, 0 10, 15 10, 15 0'
          "
        />
      </clipPath>
      <clipPath id="souce">
        <rect x="10" y="5" width="5" height="5" />
      </clipPath>
    </defs>
    <image
      v-if="props.compositionOfWok['Основа']"
      :href="props.compositionOfWok['Основа'].image || ProductNoImage"
      height="100%"
      width="100%"
      clip-path="url(#common)"
      preserveAspectRatio="xMidYMid slice"
    />
    <image
      v-if="props.compositionOfWok['Начинка']"
      :href="props.compositionOfWok['Начинка'].image || ProductNoImage"
      height="100%"
      width="100%"
      preserveAspectRatio="xMidYMid slice"
      clip-path="url(#fill)"
    />
    <image
      v-if="props.compositionOfWok['Соус']"
      x="10"
      y="5"
      :href="props.compositionOfWok['Соус'].image || ProductNoImage"
      height="5"
      width="5"
      clip-path="url(#souce)"
    />
  </svg>
</template>
